// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React from 'react'
import { Navigate, Route, useLocation } from 'react-router-dom';
import {jwtDecode} from "jwt-decode";
import Cookies from "js-cookie";
import { AuthContext } from "./signin/AuthContext";
import { useContext } from "react";

export default function PrivateRoute({ children }: { children: ReactElement }) {
    const {token, setToken } = useContext(AuthContext);
    // Add your own authentication on the below line.
    const tokenIsValid = (token) => {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return currentTime < decodedToken.exp;
    };
    var loggedIn = false;
    
    if (!token || !tokenIsValid(token)) {
        localStorage.setItem("authenticated", false);
        localStorage.removeItem('token');
        localStorage.removeItem('JWT');
        loggedIn = false;
    }
    else {
        loggedIn = true;
    }
    if (!loggedIn) {
        return <Navigate to={{ pathname: '/' }} />;
    }

    return children;
}

